export function formatDocumentTitle(title: string) {
  return `${title} | DIS`;
}
